import ApiService from "../api";

export default class FortesFinanceiroService extends ApiService {

    constructor() {
        super('/api/fortes/ag')
    }

    listaContasPagar(params) {
        return this.get(`/despesas?codigoEmpresa=${params.codigoEmpresa}&dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}`)
    }


    relatorios(params) {
        return this.get(`/despesas/relatorios?codigoEmpresa=${params.codigoEmpresa}&dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}`)
    }

    exportarDespesaExcel(params) {
        return this.getFile(`/despesas/exportar?codigoEmpresa=${params.codigoEmpresa}&dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}`)
    }

    buscarEmpresas() {
        return this.get(`/empresas`)
    }

    listarContasFinanceiras() {
        return this.get(`/contas-financeiras`)
    }
}